import { createFileRoute } from "@tanstack/react-router";
import { seo } from "@utils/seo";
import i18n from "@modules/shared/localization/i18n";
import { allArticlesQueryOptions } from "@modules/shopify/hooks";
import { getCountryVariables } from "@/modules/shared/localization/const/countries";
import { BlogPageView } from "@modules/shop/components/Blog/BlogPageView";

export const Route = createFileRoute("/$locale/_layout/(public)/_public/blog/")(
  {
    component: BlogPage,
    ssr: true,
    loader: async ({ context: { queryClient }, params }) => {
      const localeVars = getCountryVariables(params.locale);
      await queryClient.ensureQueryData(
        allArticlesQueryOptions({
          first: 24,
          ...localeVars,
        })
      );
    },
    staleTime: 60_000,
    headers: () => ({
      "Cache-Control":
        "public, max-age=300, s-maxage=300, stale-while-revalidate=86400",
    }),
    head: ({ params }) => {
      const t = i18n.getFixedT(params.locale);
      return {
        meta: [
          ...seo({
            title: t("Seo:blog.title"),
            description: t("Seo:blog.description"),
          }),
        ],
      };
    },
  }
);

function BlogPage() {
  const { locale } = Route.useParams();
  return <BlogPageView locale={locale} />;
}
